import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Role } from 'src/app/classes/auth/role.class';
import { User } from 'src/app/classes/user.class';
import { AuthorisationService } from '../../../services/auth/authorisation.service';
import { UserService } from '../../../services/user/user.service';

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss'],
    standalone: false,
})
export class UserFormComponent {
    private fb = inject(FormBuilder);
    private authorisationService = inject(AuthorisationService);
    private userService = inject(UserService);
    form: FormGroup;
    roles: Role[] = [];
    loading = false;

    @Output() userCreated = new EventEmitter<User>();

    constructor(private dialogRef: MatDialogRef<UserFormComponent>) {
        this.form = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            role: [null, Validators.required],
        });
        this.loadRoles();
    }

    loadRoles() {
        this.authorisationService.getRoles().subscribe((roles: Role[]) => {
            this.roles = roles.filter(r => r.is_external);
        });
    }

    save() {
        if (this.form.invalid) return;

        this.loading = true;

        const user = {
            name: this.form.value.name,
            email: this.form.value.email,
            roles: [this.form.value.role],
        };

        this.userService
            .saveUser(user as User)
            .then(savedUser => {
                this.userCreated.emit(savedUser);
                this.dialogRef.close(savedUser);
            })
            .finally(() => (this.loading = false));
    }

    close() {
        this.dialogRef.close();
    }
}
